import { render, staticRenderFns } from "./clazzposter.vue?vue&type=template&id=19df65dc&"
import script from "./clazzposter.vue?vue&type=script&lang=js&"
export * from "./clazzposter.vue?vue&type=script&lang=js&"
import style0 from "./clazzposter.vue?vue&type=style&index=0&id=19df65dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports